(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /*
   * PRODUCT SORTING
   *
   * Available products stay first.
   * Sold-out products are moved to the bottom.
   *
   * The original order of the available products is preserved.
   * Therefore, if the collection is sorted by newest first,
   * the newest available products remain at the top.
   */

  function moveSoldOutToBottom(root = document) {
    const grids = root.querySelectorAll('.product-grid');

    grids.forEach((grid) => {
      const products = Array.from(
        grid.querySelectorAll('.product-grid__item')
      );

      if (products.length < 2) return;

      const availableProducts = products.filter(
        (product) => product.dataset.available === 'true'
      );

      const soldOutProducts = products.filter(
        (product) => product.dataset.available === 'false'
      );

      if (soldOutProducts.length === 0) return;

      const desiredOrder = [
        ...availableProducts,
        ...soldOutProducts
      ];

      const currentOrder = products.map(
        (product) => product.dataset.productId
      );

      const newOrder = desiredOrder.map(
        (product) => product.dataset.productId
      );

      const orderIsAlreadyCorrect =
        currentOrder.length === newOrder.length &&
        currentOrder.every(
          (id, index) => id === newOrder[index]
        );

      if (orderIsAlreadyCorrect) return;

      const fragment = document.createDocumentFragment();

      desiredOrder.forEach((product) => {
        fragment.appendChild(product);
      });

      grid.appendChild(fragment);
    });
  }

  /*
   * Run after the initial page has loaded.
   */
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      moveSoldOutToBottom();
    },
    { once: true }
  );

  /*
   * Horizon uses dynamic rendering and infinite scroll.
   * This observer makes sure the sorting is reapplied
   * whenever new products are loaded or filters are changed.
   */
  const soldOutObserver = new MutationObserver((mutations) => {
    let shouldSort = false;

    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        shouldSort = true;
      }
    });

    if (shouldSort) {
      requestAnimationFrame(() => {
        moveSoldOutToBottom();
      });
    }
  });

  soldOutObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  } catch(e) { console.error(e); }
})();
})();
